var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      ref: "view"
    },
    [
      _c(
        "WrapVue",
        {
          attrs: {
            noTransition: _vm.wrapNoTransition,
            opacity: _vm.wrapOpacity,
            showWrap: _vm.showWrap
          },
          on: { onCloseWrap: _vm.onClose }
        },
        [
          _c(
            "div",
            {
              ref: "mediaRef",
              staticClass: "media-content",
              on: {
                dragstart: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _vm._l(_vm.mediaDatas, function(item, index) {
                return _vm.isCreated(index)
                  ? _c("img", {
                      key: index,
                      ref: "imgRefs" + index,
                      refInFor: true,
                      class: ["img-transition-" + _vm.transition.img.timing],
                      style:
                        (index === _vm.imageAttr.index
                          ? _vm.imageAttr.style
                          : _vm.otherImgStyle(index)) +
                        "; " +
                        (_vm.transition.img.duration > 0
                          ? "transition-duration: " +
                            _vm.transition.img.duration +
                            "s"
                          : "") +
                        ";",
                      attrs: {
                        id: _vm.imageIds[index],
                        src: item,
                        alt: "image load failed"
                      },
                      on: {
                        load: function($event) {
                          _vm.imgLoaded(index, $event)
                        }
                      }
                    })
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading"
                  }
                ],
                staticStyle: { "z-index": "1", width: "1rem", height: "1rem" },
                attrs: { src: require("./loading.gif") }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.gbOpacity >= 0,
                  expression: "gbOpacity >= 0"
                }
              ],
              staticClass: "gallery-bar",
              style: { opacity: _vm.gbOpacity }
            },
            [
              _vm._t("galleryBar", [
                _c("ul", [
                  _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          _vm.gallery.doClose()
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "1.5rem", width: "1.5rem" },
                        attrs: {
                          src:
                            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAERSURBVGhD7ZlBDoMwDAS5lGv/2kf2WYCNshIHiEKINw7ySKgo1N6dc6YgCIL3sa7rJ73SaZYti77Lsvzl+aUjGpqp2dohHdUBCfndYcpoVorV3HoZGZyPEoAhc5QAqcuc/nKPs4WKpYxZJlPGPIshw8jYsQyiSQCLQLoEaBncTQK0KNBdAjwp4kYC1BRyJwHuFHMrAUoKupcAuaLDSICrwme4lQAlMu4lQE5mGAnlFSI5CeBepkQCuJW5ktDz3Lc07oOSou5l7hR0K1NTzJ3Mk0JuZFoU6S7TskA3GYtguoxlIE2GEWSewZAAZllMCdA8U2bfc60gg+Nf9ABdoIuYEkAzm0gAWTT+ZWgQBIEjpmkDLkjTj6GOoUkAAAAASUVORK5CYII="
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.imageAttr.index + 1) +
                        "/" +
                        _vm._s(_vm.mediaDatas.length)
                    )
                  ])
                ])
              ])
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }